var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvalidLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "link_to_be_updated",
    d: "M15.5,31A15.5,15.5,0,0,1,4.54,4.54,15.5,15.5,0,0,1,26.46,26.46,15.4,15.4,0,0,1,15.5,31ZM13.688,12.482a4.061,4.061,0,0,0-2.892,1.2l-3.605,3.6a4.078,4.078,0,0,0,5.768,5.767l3.424-3.424A.765.765,0,1,0,15.3,18.546l-3.425,3.424a2.549,2.549,0,0,1-3.6-3.6l3.6-3.6a2.526,2.526,0,0,1,3.459-.136.767.767,0,1,0,1-1.165A4.052,4.052,0,0,0,13.688,12.482Zm.721,2.951a.767.767,0,0,0-.5,1.35,4.08,4.08,0,0,0,5.537-.22l3.6-3.6a4.078,4.078,0,0,0-5.767-5.768L13.86,10.616A.765.765,0,1,0,14.942,11.7l3.424-3.425a2.549,2.549,0,0,1,3.6,3.6l-3.6,3.6a2.526,2.526,0,0,1-3.459.136A.768.768,0,0,0,14.409,15.433Z",
    fill: "red"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidLink);
export default __webpack_public_path__ + "static/media/invalidLink.84881ac2.svg";
export { ForwardRef as ReactComponent };